/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, Icon } from '@components/atoms'

import { grey } from '@mui/material/colors'

interface GoTopProps {
	show: boolean
	onClick: () => void
}

export const GoTop: React.FC<GoTopProps> = ({ show, onClick }) => {
	return (
		<View css={style} className={`goTop ${show ? 'visible' : ''}`} onClick={onClick}>
			<View className="goTopIconView">
				<Icon name="format-vertical-align-top" className="goTopIcon" />
			</View>
			<Text className="goTopTitle" category="h5">
				Top
			</Text>
		</View>
	)
}

const style = css({
	position: 'fixed',
	zIndex: 5,
	display: 'none',
	alignItems: 'center',
	justifyContent: 'center',
	bottom: '20px',
	right: '20px',
	width: 'fit-content',
	color: 'white',
	fontSize: '18px',
	textAlign: 'center',
	cursor: 'pointer',
	transition: 'opacity 0.3s ease',

	'&.visible': {
		display: 'block',
		// alignItems
	},
	'&.hover': {
		backgroundColor: grey[900],
	},

	'.goTopIconView': {
		width: '4rem',
		height: '4rem',
		marginBottom: '0.5rem',
		backgroundColor: grey[900],
		boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
		borderRadius: '50%',

		'.goTopIcon': {
			width: '100%',
			fontSize: '50px',
			color: 'white',
		},
	},

	'.goTopTitle': {
		width: '100%',
		margin: 0,
		color: grey[900],
	},
})
